module.exports = __webpack_public_path__ + "img/ios.0d216c45.webp";